import React from 'react';
import './Features.css';

const features = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2.5 4.5 5.5v5.2c0 4.6 3.2 7.9 7.5 9.8 4.3-1.9 7.5-5.2 7.5-9.8V5.5L12 2.5Z" />
        <path d="M12 14.5c-2.4 0-3.6-1.8-3.6-3.9 1.9 0 3.6 1 3.6 3.9Z" />
        <path d="M12 14.5c2.4 0 3.6-1.8 3.6-3.9-1.9 0-3.6 1-3.6 3.9Z" />
        <path d="M12 14.5V9.2" />
      </svg>
    ),
    title: 'Rugged By Design',
    text: 'Premium materials and advanced protection.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="var(--color-accent)" stroke="var(--color-accent)" strokeWidth="1" strokeLinejoin="round">
        <path d="M2.5 19 8 9.5l3.2 4.8L14.5 8l7 11H2.5Z" />
        <path d="M7 11.2 8.4 9l1.3 2-1.4.6-1.3-.4Z" fill="#fff" stroke="none" />
        <path d="M13.4 9.6 14.5 8l1.2 1.9-1.4.3-.9-.6Z" fill="#fff" stroke="none" />
      </svg>
    ),
    title: 'Extreme Performance',
    text: 'Power, control, and stability on the most demanding terrains.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    ),
    title: 'Built To Last',
    text: 'Long-life components and precision manufacturing for years of reliability.',
  },
];

function Features() {
  return (
    <section className="features">
      <div className="features__inner">
        <span className="features__eyebrow">BUILT WITHOUT COMPROMISE</span>
        <h2 className="features__heading">
          Built For Toughness.<br />
          Designed For Extreme Conditions.
        </h2>
        <p className="features__sub">
          Every Acriolis ATV is engineered with precision and tested in extreme conditions,<br />
          to deliver unstoppable performance wherever you go.
        </p>

        <div className="features__grid">
          {features.map((f) => (
            <div className="features__item" key={f.title}>
              <span className="features__icon">{f.icon}</span>
              <div className="features__item-text">
                <h3 className="features__item-title">{f.title}</h3>
                <p className="features__item-desc">{f.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
